
























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class BusinessConnectionHeader extends Vue {
    @Prop({ required: true }) myFirstName!: string
    @Prop({ required: true }) connectionDate!: string
    @Prop({ required: true }) connectedMemberFullName!: string
    @Prop({ required: true }) connectedMemberCompany!: string
    @Prop({ required: true }) formType!:
        | 'business_connection_for_partner_contact'
        | 'business_connection_rdv_for_partner_contact'
}
